import { PDFDocument, rgb } from 'pdf-lib';

// Función para convertir centímetros a puntos
const cmToPoints = (cm) => cm * 28.35;

class PdfGenerator {
  constructor(formData, ruc) {
    this.formData = formData;
    this.ruc = ruc;
    this.url = '/pdfAsociados.pdf';
  }

  async generatePdf() {
    try {
      const existingPdfBytes = await fetch(this.url).then((res) =>
        res.arrayBuffer()
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const secondPage = pages[1];

      const { height } = firstPage.getSize();

      const fontSize = 7;

      // Coordenadas para "Fecha"
      const xDate = cmToPoints(16.75);
      const yDate = height - cmToPoints(3.45);

      const currentDate = new Date().toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      firstPage.drawText(currentDate, {
        x: xDate,
        y: yDate,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Nº Partida Electrónica"
      const xpublic_reg = cmToPoints(12.4);
      const ypublic_reg = height - cmToPoints(6.3);

      firstPage.drawText(this.formData.public_reg, {
        x: xpublic_reg,
        y: ypublic_reg,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Fecha de fundación"
      const xanniversary_date = cmToPoints(4.7);
      const yanniversary_date = height - cmToPoints(7.2);

      firstPage.drawText(this.formData.anniversary_date, {
        x: xanniversary_date,
        y: yanniversary_date,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "RUC"
      const xruc = cmToPoints(12.4);
      const yruc = height - cmToPoints(7.2);

      firstPage.drawText(this.ruc, {
        x: xruc,
        y: yruc,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Razón Social"
      const xRazónSocial = cmToPoints(3.8);
      const yRazónSocial = height - cmToPoints(8);

      firstPage.drawText(this.formData.razonSocial, {
        x: xRazónSocial,
        y: yRazónSocial,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Nombre Comercial"
      const xNombreComercial = cmToPoints(3.8);
      const yNombreComercial = height - cmToPoints(8.9);

      firstPage.drawText(this.formData.nombreComercial, {
        x: xNombreComercial,
        y: yNombreComercial,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Direccion"
      const xdireccion = cmToPoints(3.8);
      const ydireccion = height - cmToPoints(9.7);

      firstPage.drawText(this.formData.direccion, {
        x: xdireccion,
        y: ydireccion,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Telefonos"
      const xtelefonos = cmToPoints(3.8);
      const ytelefonos = height - cmToPoints(10.55);

      firstPage.drawText(this.formData.telefonos, {
        x: xtelefonos,
        y: ytelefonos,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Email"
      const xemail = cmToPoints(3.8);
      const yemail = height - cmToPoints(11.4);

      firstPage.drawText(this.formData.email, {
        x: xemail,
        y: yemail,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Pagina Web"
      const xpaginaWeb = cmToPoints(13.5);
      const ypaginaWeb = height - cmToPoints(10.55);

      firstPage.drawText(this.formData.paginaWeb, {
        x: xpaginaWeb,
        y: ypaginaWeb,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "direccion Correspondencia"
      const xdireccionCorrespondencia = cmToPoints(4.3);
      const ydireccionCorrespondencia = height - cmToPoints(12.35);

      firstPage.drawText(this.formData.direccionCorrespondencia, {
        x: xdireccionCorrespondencia,
        y: ydireccionCorrespondencia,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Apellidos, Nombres (Ejecutivo #1)"
      const xEjecutivo1 = cmToPoints(4.7);
      const yEjecutivo1 = height - cmToPoints(14.3);

      const ejecutivo1Text = `${this.formData.last_name_1}, ${this.formData.names_1}`;

      firstPage.drawText(ejecutivo1Text, {
        x: xEjecutivo1,
        y: yEjecutivo1,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Cargo (Ejecutivo #1)"
      const xcharge_1 = cmToPoints(15.2);
      const ycharge_1 = height - cmToPoints(14.3);

      firstPage.drawText(this.formData.charge_1, {
        x: xcharge_1,
        y: ycharge_1,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Email (Ejecutivo #1)"
      const xemail_1 = cmToPoints(12.4);
      const yemail_1 = height - cmToPoints(15.2);

      firstPage.drawText(this.formData.email_1, {
        x: xemail_1,
        y: yemail_1,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Telefono (Ejecutivo #1)"
      const xphone_1 = cmToPoints(3.8);
      const yphone_1 = height - cmToPoints(15.2);

      firstPage.drawText(this.formData.phone_1, {
        x: xphone_1,
        y: yphone_1,
        size: fontSize,
        color: rgb(0, 0, 0),
      });
      
      // Coordenadas para "Apellidos, Nombres (Ejecutivo #2)"
      const xEjecutivo2 = cmToPoints(4.7);
      const yEjecutivo2 = height - cmToPoints(16.35);

      const ejecutivo2Text = `${this.formData.last_name_2}, ${this.formData.names_2}`;

      firstPage.drawText(ejecutivo2Text, {
        x: xEjecutivo2,
        y: yEjecutivo2,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Cargo (Ejecutivo #2)"
      const xcharge_2 = cmToPoints(15.2);
      const ycharge_2 = height - cmToPoints(16.4);

      firstPage.drawText(this.formData.charge_2, {
        x: xcharge_2,
        y: ycharge_2,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Email (Ejecutivo #2)"
      const xemail_2 = cmToPoints(12.4);
      const yemail_2 = height - cmToPoints(17.35);

      firstPage.drawText(this.formData.email_2, {
        x: xemail_2,
        y: yemail_2,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Telefono (Ejecutivo #2)"
      const xphone_2 = cmToPoints(3.8);
      const yphone_2 = height - cmToPoints(17.35);

      firstPage.drawText(this.formData.phone_2, {
        x: xphone_2,
        y: yphone_2,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Apellidos, Nombres (Ejecutivo #3)"
      const xContactoCorrespondencia = cmToPoints(4.7);
      const yContactoCorrespondencia = height - cmToPoints(18.6);

      const ContactoCorrespondenciaText = `${this.formData.last_name_3}, ${this.formData.names_3}`;

      firstPage.drawText(ContactoCorrespondenciaText, {
        x: xContactoCorrespondencia,
        y: yContactoCorrespondencia,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Cargo (Ejecutivo #3)"
      const xcharge_3 = cmToPoints(15.2);
      const ycharge_3 = height - cmToPoints(18.6);

      firstPage.drawText(this.formData.charge_3, {
        x: xcharge_3,
        y: ycharge_3,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Email (Ejecutivo #3)"
      const xemail_3 = cmToPoints(12.4);
      const yemail_3 = height - cmToPoints(19.6);

      firstPage.drawText(this.formData.email_3, {
        x: xemail_3,
        y: yemail_3,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Telefono (Ejecutivo #3)"
      const xphone_3 = cmToPoints(3.8);
      const yphone_3 = height - cmToPoints(19.6);

      firstPage.drawText(this.formData.phone_3, {
        x: xphone_3,
        y: yphone_3,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Apellidos, Nombres (Ejecutivo #4)"
      const xEjecutivo4 = cmToPoints(4.7);
      const yEjecutivo4 = height - cmToPoints(20.9);

      const Ejecutivo4Text = `${this.formData.last_name_4}, ${this.formData.names_4}`;

      firstPage.drawText(Ejecutivo4Text, {
        x: xEjecutivo4,
        y: yEjecutivo4,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Cargo (Ejecutivo #4)"
      const xcharge_4 = cmToPoints(15.2);
      const ycharge_4 = height - cmToPoints(20.9);

      firstPage.drawText(this.formData.charge_4, {
        x: xcharge_4,
        y: ycharge_4,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Email (Ejecutivo #4)"
      const xemail_4 = cmToPoints(12.4);
      const yemail_4 = height - cmToPoints(21.85);

      firstPage.drawText(this.formData.email_4, {
        x: xemail_4,
        y: yemail_4,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Telefono (Ejecutivo #4)"
      const xphone_4 = cmToPoints(3.8);
      const yphone_4 = height - cmToPoints(21.85);

      firstPage.drawText(this.formData.phone_4, {
        x: xphone_4,
        y: yphone_4,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Sector Económico"
      const xeconomic_section = cmToPoints(13);
      const yeconomic_section = height - cmToPoints(23.5);

      firstPage.drawText(this.formData.economic_section, {
        x: xeconomic_section,
        y: yeconomic_section,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "descripción"
      const xdescription = cmToPoints(1.9);
      const ydescription = height - cmToPoints(24.5);

      const xLimit = cmToPoints(19);

      function getTextWidth(text, fontSize) {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = `${fontSize}px sans-serif`;
        return context.measureText(text).width;
      }

      function wrapText(text, fontSize, xStart, xLimit) {
        const words = text.split(' ');
        let lines = [];
        let currentLine = '';

        for (let i = 0; i < words.length; i++) {
          const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
          const testWidth = getTextWidth(testLine, fontSize);

          if (testWidth > xLimit - xStart) {
            lines.push(currentLine);
            currentLine = words[i];
          } else {
            currentLine = testLine;
          }
        }

        if (currentLine) {
          lines.push(currentLine);
        }

        return lines;
      }

      const lines = wrapText(this.formData.description, fontSize, xdescription, xLimit);

      let currentY = ydescription;
      lines.forEach(line => {
        firstPage.drawText(line, {
          x: xdescription,
          y: currentY,
          size: fontSize,
          color: rgb(0, 0, 0),
        });
        currentY -= fontSize * 1.2;
      });


      // Coordenadas para "N° de empleados"
      const xnumber_employees = cmToPoints(2.5);
      const ynumber_employees = height - cmToPoints(27);

      const empleadosText = `${this.formData.number_employees} empleados`;

      firstPage.drawText(empleadosText, {
        x: xnumber_employees,
        y: ynumber_employees,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Patrimonio (en Soles)"
      const xheritage = cmToPoints(8);
      const yheritage = height - cmToPoints(27);

      const patrimonioText = ` S/. ${this.formData.heritage}`;

      firstPage.drawText(patrimonioText, {
        x: xheritage,
        y: yheritage,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Venta Anual (en Soles)"
      const xanual_sale = cmToPoints(14);
      const yanual_sale = height - cmToPoints(27);

      const anual_saleText = ` S/. ${this.formData.anual_sale}`;

      firstPage.drawText(anual_saleText, {
        x: xanual_sale,
        y: yanual_sale,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Persona que autoriza"
      const xauthorization_person = cmToPoints(2.5);
      const yauthorization_person = height - cmToPoints(18);

      secondPage.drawText(this.formData.authorization_person, {
        x: xauthorization_person,
        y: yauthorization_person,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Coordenadas para "Cargo de la persona que autoriza"
      const xauthorization_person_charge = cmToPoints(8.7);
      const yauthorization_person_charge = height - cmToPoints(18);

      secondPage.drawText(this.formData.authorization_person_charge, {
        x: xauthorization_person_charge,
        y: yauthorization_person_charge,
        size: fontSize,
        color: rgb(0, 0, 0),
      });

      // Guardar el documento PDF modificado
      const pdfBytes = await pdfDoc.save();

      return pdfBytes;
    } catch (error) {
      console.error('Error al generar el PDF:', error);
    }
  }

  // Método para generar y descargar el PDF
  async downloadPdf() {
    const pdfBytes = await this.generatePdf();

    if (pdfBytes) {
      // Crear un blob y generar un enlace de descarga
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Solicitud_asociado.pdf';
      link.click();
      console.log('PDF descargado correctamente');
    } else {
      console.error('No se generó el PDF.');
    }
  }
}

export default PdfGenerator;
